module.exports = __webpack_public_path__ + "img/2012-12-14 20.13.27.87a01268.jpg";